import { makeStyles } from '@material-ui/core';

export default makeStyles({
  expandedCell: {
    padding: '0 8px',
  },
});
